const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

export const authService = {
  setTokens(accessToken, refreshToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },
  setToken(token) {
    // 기존 setToken 유지 (필요 시 제거)
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  },
  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },
  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },
  removeTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    // 운영진 보기 중에 로그아웃하면 쥐고 있던 운영진 토큰도 버린다(components/AdminViewPicker.jsx)
    localStorage.removeItem("admin_origin_access_token");
    localStorage.removeItem("admin_origin_refresh_token");
  },
  isAuthenticated() {
    return !!localStorage.getItem(ACCESS_TOKEN_KEY);
  }
};